import React, { Component } from "react";
import {
  Button, Input, Select, Tag, Progress, Upload,
  notification, Spin, Row, Col, Tooltip,
} from "antd";
import {
  LoadingOutlined, CheckCircleFilled, RocketOutlined,
  UserOutlined, TeamOutlined, SoundOutlined, ScheduleOutlined,
  HeartOutlined, StarOutlined, CameraOutlined, ThunderboltOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Storage } from "aws-amplify";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { update } from "../api/Apis";
import { withAppContext } from "../store/contextStore";

const { Option } = Select;
const { TextArea } = Input;

const STEPS = [
  { id:"ai_scan",    icon:<ThunderboltOutlined />, label:"AI Scan"      },
  { id:"invited_by", icon:<TeamOutlined />,         label:"Referred By"  },
  { id:"basics",     icon:<UserOutlined />,         label:"Your Info"   },
  { id:"practice",   icon:<StarOutlined />,         label:"Practice"    },
  { id:"clients",    icon:<TeamOutlined />,         label:"Clients"     },
  { id:"voice",      icon:<SoundOutlined />,        label:"Voice"       },
  { id:"content",    icon:<ScheduleOutlined />,     label:"Content"     },
  { id:"life",       icon:<HeartOutlined />,        label:"Your Life"   },
  { id:"preview",    icon:<RocketOutlined />,       label:"Preview"     },
];

const SPECIALTIES = [
  "Buyer representation","Seller representation","Downsizing","Upsizing",
  "Relocation","Investment properties","Flipping","1031 exchanges","Commercial",
  "Land","New Construction","Builder representation","Waterfront properties",
  "Farm/horse properties","Rentals","First Time Buyers","Short Sales",
  "Business Representation","Over 55/Active Adult","Bank Owned",
];

const CLIENT_TYPES = [
  "First-time buyers","Move-up buyers","Downsizers","Investors",
  "Luxury buyers","Relocation clients","Empty nesters","Military/VA",
  "Self-employed","Divorcing couples","Estate sales","International buyers",
];

const HOBBIES = [
  "🏃 Running","🚴 Cycling","🧘 Yoga","⛳ Golf","🎾 Tennis","🏊 Swimming",
  "🍳 Cooking","🌱 Gardening","📚 Reading","✈️ Travel","🎵 Music","🎨 Art",
  "🐾 Pets","🏔️ Hiking","📸 Photography","⛷️ Skiing","🏂 Snowboarding",
  "🎣 Fishing","⚽ Soccer","🏀 Basketball","⚾ Baseball","🏈 Football",
  "🎯 Hunting","🚣 Kayaking","🏄 Surfing","🎸 Guitar","🍷 Wine & Food",
  "🏋️ Fitness","🧗 Rock Climbing","🎲 Board Games","🎬 Movies",
];

const WHY_VALUES = [
  "Community first","Integrity always","Family-driven","Client advocacy",
  "Education & empowerment","Long-term relationships","Local expertise",
  "Transparency","Innovation","Giving back",
];

const NAVY  = "#1A2280";
const GOLD  = "#D4921A";
const BG    = "#F7F9FC";
const BORDER = "#E2E8F0";
const MUTED = "#718096";
const SUCCESS = "#38A169";

const chip = (active) => ({
  display:"inline-block", padding:"6px 14px", borderRadius:"20px",
  fontSize:"13px", cursor:"pointer", margin:"4px",
  fontWeight: active ? 700 : 400,
  background: active ? NAVY : "#fff",
  color: active ? "#fff" : "#1A202C",
  border:`1.5px solid ${active ? NAVY : BORDER}`,
  transition:"all .15s",
});

const btn = (variant) => ({
  borderRadius:"50px", fontWeight:700, fontSize:"14px",
  height:"42px", padding:"0 24px",
  background: variant==="primary" ? NAVY : variant==="gold" ? GOLD : "transparent",
  color: variant==="primary" ? "#fff" : variant==="gold" ? "#2A1600" : MUTED,
  border: variant==="ghost" ? `1.5px solid ${BORDER}` : "none",
});

class ProfileCompletionModal extends Component {
  constructor(props) {
    super(props);
    const ud = props.userDetails || {};
    const nd = ud.newdata || {};
    this.state = {
      step: 0,
      aiScanning: false,
      aiScanDone: false,
      saving: false,
      generatingPreview: false,
      previewPost: "",
      uploadingPhoto: false,
      // Invited by
      invitedByAgentId: "",
      invitedByAgentName: "",
      invitedByLocked: false,
      allAgents: [],
      inviteRefLoaded: false,
      photoUrl: ud.profilePicture?.[0]
        ? `https://homeslistedby-prod-attachments.s3.amazonaws.com/public/${ud.profilePicture[0]}`
        : "",
      photoFileKey: ud.profilePicture?.[0] || "",
      serviceAreas: Array.isArray(nd.serviceAreas)
        ? nd.serviceAreas.map(function(a) {
            return typeof a === "object" ? (a.cityName || a.name || "") : a;
          }).filter(Boolean)
        : nd.serviceAreas ? [nd.serviceAreas] : [],
      zipCodes: nd.zipCodes || [],
      zipInput: "",
      form: {
        firstName:     ud.firstName    || "",
        lastName:      ud.lastName     || "",
        phone:         ud.phone        || "",
        companyName:   nd.companyName  || "",
        title:         nd.titleorPosition || "",
        website:       nd.website      || "",
        licenseIds:    ud.licenseIds   || "",
        mlsId:         ud.mlsId        || "",
        language:      nd.language     || "English",
        userBio:       ud.userBio      || "",
        profileUrl:    ud.profileUrl   || `${ud.firstName || ""}${ud.lastName || ""}`.replace(/\s+/g,""),
        specialties:   Array.isArray(nd.Specialties)
          ? nd.Specialties.map(function(s){ return typeof s === "object" ? (s.value || s.name || "") : s; }).filter(Boolean)
          : [],
        experience:    "",
        unique_angle:  "",
        client_types:  [],
        price_range:   "",
        voice_tone:    "",
        emoji_usage:   "",
        opinion_level: "",
        cta_style:     "",
        platforms:     [],
        posting_freq:  "",
        post_length:   "",
        content_mix:   "",
        hobbies:       [],
        family_stage:  "",
        grew_up:       "",
        why_values:    [],
        origin_story:  "",
        fun_fact:      "",
        local_love:    "",
        great_work_day:"",
        brand_word:    "",
        facebook:      ud.socialMedia?.facebook   || "",
        instagram:     ud.socialMedia?.instagram  || "",
        linkedin:      ud.socialMedia?.Linkedin   || "",
        youtube:       ud.socialMedia?.youtube    || "",
        twitter:       ud.socialMedia?.twitter    || "",
      },
    };
  }

  setForm = (field, val) =>
    this.setState(p => ({ form:{...p.form,[field]:val} }));

  toggleChip = (field, val, max=99) =>
    this.setState(p => {
      const arr = p.form[field]||[];
      const has = arr.includes(val);
      if(!has && arr.length>=max) return p;
      return {form:{...p.form,[field]:has?arr.filter(x=>x!==val):[...arr,val]}};
    });

  componentDidMount() {
    this.loadInviteRef();
    this.loadAllAgents();
  }

  loadAllAgents = async () => {
    try {
      const { noAuthlist } = require("../api/Apis");
      const res = await noAuthlist("getUsers?userProfile=AG");
      const lenders = await noAuthlist("getUsers?userProfile=L");
      const all = [...(res.data || []), ...(lenders.data || [])];
      this.setState({ allAgents: all });
      const { invitedByAgentId } = this.state;
      if (invitedByAgentId) {
        const match = all.find(a => a.id === invitedByAgentId);
        if (match) {
          this.setState({ invitedByAgentName: match.firstName + " " + match.lastName });
        }
      }
    } catch (e) {
      console.log("Could not load agents for invite step", e);
    }
  };

  loadInviteRef = () => {
    const userDetails = this.props.userDetails || {};
    if (userDetails.profile_completed) return;
    if (userDetails.invitedBy) {
      this.setState({ invitedByAgentId: userDetails.invitedBy, invitedByLocked: true, inviteRefLoaded: true });
      return;
    }
    try {
      const raw = sessionStorage.getItem("inviteRef");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed.agentId) {
          // Lock the referrer — they came via invite link, should not be changeable
          this.setState({ invitedByAgentId: parsed.agentId, invitedByLocked: true, inviteRefLoaded: true });
        }
      }
    } catch (e) {}
  };

  // ── FIX: handleDismiss — save minimal progress and close ──────────────────
  handleDismiss = async () => {
    const { form, invitedByAgentId } = this.state;
    const ud = this.props.userDetails || {};
    // Save whatever we have so far — name, phone, invitedBy at minimum
    try {
      const payload = { entityData: {
        firstName: form.firstName || ud.firstName,
        lastName:  form.lastName  || ud.lastName,
        phone:     form.phone     || ud.phone,
        ...(invitedByAgentId && invitedByAgentId !== "none" && !ud.invitedBy
          ? { invitedBy: invitedByAgentId }
          : {}),
      }};
      if (ud.id) await update("users", ud.id, payload);
    } catch(e) {
      console.warn("Dismiss save failed:", e.message);
    }
    if (this.props.onDismiss) this.props.onDismiss();
    else if (this.props.onComplete) this.props.onComplete();
  };

  renderInvitedBy = () => {
    const { invitedByAgentId, invitedByAgentName, invitedByLocked, allAgents } = this.state;

    const agentOptions = allAgents
      .map(a => ({
        value: a.id,
        label: a.firstName + " " + a.lastName + (a.newdata && a.newdata.companyName ? " — " + a.newdata.companyName : ""),
      }))
      .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

    const resolvedName = invitedByAgentId
      ? (invitedByAgentName || (agentOptions.find(a => a.value === invitedByAgentId) || {}).label || "Loading...")
      : null;

    return (
      <div>
        <div style={{ fontWeight: 700, fontSize: "18px", color: NAVY, marginBottom: "6px" }}>
          Who invited you? 🤝
        </div>
        <div style={{ color: MUTED, fontSize: "13px", marginBottom: "24px" }}>
          Help us connect you with your referring partner. You can skip this if you found us on your own.
        </div>

        {invitedByLocked ? (
          <div style={{ background: "#fffbf0", border: "1.5px solid " + GOLD, borderRadius: "12px", padding: "16px 20px" }}>
            <div style={{ fontSize: "13px", color: MUTED, marginBottom: "4px" }}>You were referred by</div>
            <div style={{ fontWeight: 700, fontSize: "16px", color: NAVY }}>{resolvedName}</div>
            <div style={{ fontSize: "11px", color: MUTED, marginTop: "6px" }}>This has been saved and cannot be changed.</div>
          </div>
        ) : invitedByAgentId && invitedByAgentId !== "none" && resolvedName ? (
          <div>
            <div style={{ background: "#fffbf0", border: "1.5px solid " + GOLD, borderRadius: "12px", padding: "16px 20px", marginBottom: "16px" }}>
              <div style={{ fontSize: "13px", color: MUTED, marginBottom: "4px" }}>You were invited by</div>
              <div style={{ fontWeight: 700, fontSize: "16px", color: NAVY }}>{resolvedName}</div>
              <div
                style={{ fontSize: "12px", color: GOLD, marginTop: "8px", cursor: "pointer", textDecoration: "underline" }}
                onClick={() => this.setState({ invitedByAgentId: "", invitedByAgentName: "" })}
              >
                Doesn't look right? Select a different referring partner
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ fontSize: "13px", color: "#333", marginBottom: "8px", fontWeight: 600 }}>
              Search for the agent or lender who introduced you to My Home Buddha:
            </div>
            <select
              style={{ width: "100%", padding: "10px 14px", borderRadius: "8px", border: "1.5px solid " + BORDER,
                fontSize: "14px", color: "#333", background: "#fff", marginBottom: "12px" }}
              value={invitedByAgentId}
              onChange={e => {
                const selected = agentOptions.find(a => a.value === e.target.value);
                this.setState({ invitedByAgentId: e.target.value, invitedByAgentName: selected ? selected.label : "" });
              }}
            >
              <option value="">— Select a referring partner —</option>
              {agentOptions.map(a => (
                <option key={a.value} value={a.value}>{a.label}</option>
              ))}
            </select>
            <div
              style={{ fontSize: "12px", color: MUTED, cursor: "pointer", textDecoration: "underline" }}
              onClick={() => this.setState({ invitedByAgentId: "none", invitedByAgentName: "None / Found on my own" })}
            >
              I wasn't referred by anyone
            </div>
          </div>
        )}
      </div>
    );
  };

  calcStrength = () => {
    const {form,photoUrl,serviceAreas} = this.state;
    const checks = [
      form.firstName, form.lastName, form.phone, form.companyName, form.title,
      photoUrl, form.userBio, form.unique_angle,
      form.specialties?.length>0, serviceAreas?.length>0,
      form.client_types?.length>0, form.voice_tone,
      form.platforms?.length>0, form.hobbies?.length>0, form.origin_story,
    ];
    return Math.round(checks.filter(Boolean).length/checks.length*100);
  };

  runAIScan = async () => {
    const {form} = this.state;
    const ud = this.props.userDetails||{};
    this.setState({aiScanning:true});
    try {
      const resp = await fetch("https://ai.myhomebuddha.com/.netlify/functions/claude",{
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          system:`Pre-populate a real estate agent profile. Return ONLY valid JSON:
{"companyName":"","title":"","experience":"","unique_angle":"","specialties":[],"client_types":[],"price_range":"","voice_tone":"","brand_word":"","userBio":""}
Only fill fields you can reasonably infer. Leave others as empty string or empty array.`,
          messages:[{role:"user",content:`Agent: ${form.firstName} ${form.lastName}, Email: ${ud.email||""}`}],
        }),
      });
      const data = await resp.json();
      const text = (data.content?.[0]?.text||"{}").replace(/```json|```/g,"").trim();
      const p = JSON.parse(text);
      this.setState(prev=>({
        aiScanning:false, aiScanDone:true,
        form:{
          ...prev.form,
          companyName:  p.companyName   ||prev.form.companyName,
          title:        p.title         ||prev.form.title,
          experience:   p.experience    ||prev.form.experience,
          unique_angle: p.unique_angle  ||prev.form.unique_angle,
          specialties:  p.specialties?.length ? p.specialties : prev.form.specialties,
          client_types: p.client_types?.length ? p.client_types : prev.form.client_types,
          price_range:  p.price_range   ||prev.form.price_range,
          voice_tone:   p.voice_tone    ||prev.form.voice_tone,
          brand_word:   p.brand_word    ||prev.form.brand_word,
          userBio:      p.userBio       ||prev.form.userBio,
        },
      }));
    } catch(e) {
      // FIX: on AI scan failure, mark done anyway so user isn't stuck
      this.setState({aiScanning:false, aiScanDone:true});
      notification.info({ message: "AI pre-fill skipped — fill in your details below." });
    }
  };

  handlePhotoUpload = async (info) => {
    if(info.file.status!=="done") return;
    this.setState({uploadingPhoto:true});
    try {
      const file = info.file.originFileObj;
      const key = `profile_${Date.now()}_${file.name}`;
      await Storage.put(key,file,{contentType:file.type});
      const url = await Storage.get(key);
      this.setState({photoUrl:url,photoFileKey:key,uploadingPhoto:false});
    } catch(e) {
      this.setState({uploadingPhoto:false});
      notification.error({message:"Photo upload failed"});
    }
  };

  generatePreview = async () => {
    const {form,serviceAreas} = this.state;
    this.setState({generatingPreview:true,previewPost:""});
    try {
      const resp = await fetch("https://ai.myhomebuddha.com/.netlify/functions/claude",{
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          system:"Write an authentic real estate agent social media post. Under 200 words. Sound like a real human.",
          messages:[{role:"user",content:`Agent: ${form.firstName} ${form.lastName}
Title: ${form.title} at ${form.companyName}
Markets: ${serviceAreas.join(", ")}
Specialties: ${form.specialties?.join(", ")}
Tone: ${form.voice_tone}, ${form.emoji_usage} emojis
Unique angle: ${form.unique_angle}
Hobbies: ${form.hobbies?.join(", ")}
Why they do this: ${form.why_values?.join(", ")}
Fun fact: ${form.fun_fact}
Write ONE post they could publish today.`}],
        }),
      });
      const data = await resp.json();
      this.setState({previewPost:data.content?.[0]?.text||"",generatingPreview:false});
    } catch(e) {
      this.setState({generatingPreview:false});
    }
  };

  handleSaveReferrerOnly = async () => {
    const { invitedByAgentId } = this.state;
    const ud = this.props.userDetails || {};
    if (!invitedByAgentId || invitedByAgentId === "none" || !ud.id) {
      this.props.onComplete();
      return;
    }
    this.setState({ saving: true });
    try {
      const { update } = await import("../api/Apis");
      const payload = { entityData: { invitedBy: invitedByAgentId } };
      const result = await update("users", ud.id, payload);
      if (result.success) {
        const updated = { ...ud, invitedBy: invitedByAgentId };
        localStorage.setItem("userDetails", JSON.stringify(updated));
        sessionStorage.removeItem("inviteRef");
        notification.success({ message: "Referrer saved — thank you! 🙏" });
      }
    } catch(e) {
      notification.error({ message: "Could not save referrer", description: e.message });
    }
    this.setState({ saving: false });
    this.props.onComplete();
  };

  // FIX: Allow save at any completion level — warn below 75% but don't block
  handleSave = async () => {
    const {form,photoUrl,photoFileKey,serviceAreas,zipCodes,invitedByAgentId} = this.state;
    const ud = this.props.userDetails||{};
    const strength = this.calcStrength();
    // No hard block — always allow save, show completion % encouragement only
    if(strength<75){
      notification.info({
        message:"Profile saved — " + strength + "% complete",
        description:"You can finish your profile anytime from Profile Settings. The more you fill in, the better your AI tools work!",
        duration: 5,
      });
    }
    this.setState({saving:true});
    try {
      const payload = {entityData:{
        firstName:      form.firstName,
        lastName:       form.lastName,
        phone:          form.phone,
        mlsId:          form.mlsId,
        userBio:        form.userBio,
        profileUrl:     form.profileUrl||(form.firstName+form.lastName).replace(/\s+/g,""),
        licenseIds:     form.licenseIds,
        profilePicture: photoFileKey?[photoFileKey]:ud.profilePicture||[],
        profile_completed: strength >= 75,  // track completion but never block save
        profile_strength: strength,
        ...(invitedByAgentId && invitedByAgentId !== "none" && !ud.invitedBy
          ? { invitedBy: invitedByAgentId }
          : {}),
        newdata:{
          companyName:     form.companyName,
          titleorPosition: form.title,
          website:         form.website,
          language:        form.language,
          serviceAreas,
          zipCodes,
          Specialties:     form.specialties,
          companyAddress:  ud.newdata?.companyAddress||"",
          mobile:          ud.newdata?.mobile||form.phone,
        },
        socialMedia: {
          facebook:  form.facebook  || "",
          instagram: form.instagram || "",
          Linkedin:  form.linkedin  || "",
          youtube:   form.youtube   || "",
          twitter:   form.twitter   || "",
          website:   form.website   || "",
        },
        agentPersonality:{
          experience:    form.experience,
          unique_angle:  form.unique_angle,
          client_types:  form.client_types,
          price_range:   form.price_range,
          voice_tone:    form.voice_tone,
          emoji_usage:   form.emoji_usage,
          opinion_level: form.opinion_level,
          cta_style:     form.cta_style,
          platforms:     form.platforms,
          posting_freq:  form.posting_freq,
          post_length:   form.post_length,
          content_mix:   form.content_mix,
          hobbies:       form.hobbies,
          family_stage:  form.family_stage,
          grew_up:       form.grew_up,
          why_values:    form.why_values,
          origin_story:  form.origin_story,
          fun_fact:      form.fun_fact,
          local_love:    form.local_love,
          great_work_day:form.great_work_day,
          brand_word:    form.brand_word,
        },
      }};
      const result = await update("users",ud.id,payload);
      if(result.success){
        const updated = {...ud,...payload.entityData};
        localStorage.setItem("userDetails",JSON.stringify(updated));
        sessionStorage.removeItem("inviteRef");
        this.props.context.setUserDetails(updated);
        if(strength>=75){
          notification.success({message:"Profile complete! Welcome to My Home Buddha. 🎉"});
        }
        this.props.onComplete();
      } else { throw new Error(result.errors); }
    } catch(e) {
      notification.error({message:"Save failed",description:e.message});
    }
    this.setState({saving:false});
  };

  // ── Render Steps ─────────────────────────────────────────────────────────────

  renderAIScan() {
    const {aiScanning,aiScanDone,form} = this.state;
    return (
      <div style={{textAlign:"center",padding:"20px 0"}}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#2A3390)`,borderRadius:"16px",padding:"28px",color:"#fff",marginBottom:"20px"}}>
          <div style={{fontSize:"44px",marginBottom:"10px"}}>⚡</div>
          <div style={{fontSize:"22px",fontWeight:800,marginBottom:"8px"}}>AI Profile Pre-Fill</div>
          <div style={{fontSize:"14px",opacity:.85,marginBottom:"20px",lineHeight:1.6}}>
            We'll pre-fill your profile using AI — saving you 10+ minutes.<br/>
            You confirm and complete what we miss.
          </div>
          {!aiScanDone ? (
            <div style={{display:"flex",gap:"10px",justifyContent:"center",flexWrap:"wrap"}}>
              <Button onClick={this.runAIScan} loading={aiScanning}
                style={{...btn("gold"),height:"44px",fontSize:"15px"}}>
                {aiScanning ? "Scanning..." : `✨ Pre-fill for ${form.firstName}`}
              </Button>
              {/* FIX: Allow skipping AI scan */}
              {!aiScanning && (
                <Button onClick={()=>this.setState({aiScanDone:true})}
                  style={{...btn("ghost"),height:"44px",fontSize:"14px",border:"1.5px solid rgba(255,255,255,0.3)",color:"rgba(255,255,255,0.7)"}}>
                  Skip — I'll fill it in myself
                </Button>
              )}
            </div>
          ) : (
            <div>
              <div style={{fontSize:"28px",marginBottom:"8px"}}>✅</div>
              <div style={{fontWeight:700,fontSize:"16px"}}>
                {aiScanDone ? "Ready — review and continue below." : "Pre-fill complete! Review below."}
              </div>
            </div>
          )}
        </div>

        {aiScanDone && (
          <div style={{textAlign:"left"}}>
            <div style={{fontSize:"18px",fontWeight:800,color:NAVY,marginBottom:"6px"}}>Confirm What We Found</div>
            <div style={{fontSize:"13px",color:MUTED,marginBottom:"16px"}}>Edit anything that looks wrong.</div>
            <Row gutter={[16,8]}>
              {[
                ["Company Name","companyName"],
                ["Title / Position","title"],
              ].map(([label,field])=>(
                <Col span={12} key={field}>
                  <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
                  <Input value={form[field]} onChange={e=>this.setForm(field,e.target.value)} style={{borderRadius:"10px"}} />
                </Col>
              ))}
              <Col span={24}>
                <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Your Unique Angle</label>
                <TextArea rows={2} value={form.unique_angle} onChange={e=>this.setForm("unique_angle",e.target.value)} style={{borderRadius:"10px"}} />
              </Col>
              <Col span={24}>
                <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Bio</label>
                <TextArea rows={3} value={form.userBio} onChange={e=>this.setForm("userBio",e.target.value)} style={{borderRadius:"10px"}} />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }

  renderBasics() {
    const {form,photoUrl,uploadingPhoto,serviceAreas,zipCodes,zipInput} = this.state;
    const dummyReq = ({onSuccess})=>setTimeout(()=>onSuccess("ok"),0);
    const FL = ({label,field,span=12})=>(
      <Col span={span}>
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
          <Input value={form[field]} onChange={e=>this.setForm(field,e.target.value)} style={{borderRadius:"10px"}} />
        </div>
      </Col>
    );
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Professional Info</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>This is what clients and agents see on your public profile.</div>

        <div style={{display:"flex",alignItems:"center",gap:"16px",marginBottom:"20px"}}>
          <div style={{width:"80px",height:"80px",borderRadius:"50%",background:"#F5E6C8",border:`3px solid ${GOLD}`,overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            {photoUrl
              ? <img src={photoUrl} alt="profile" style={{width:"100%",height:"100%",objectFit:"cover"}} />
              : <UserOutlined style={{fontSize:"28px",color:GOLD}} />
            }
          </div>
          <Upload showUploadList={false} customRequest={dummyReq} onChange={this.handlePhotoUpload} accept="image/*">
            <Button icon={<CameraOutlined />} loading={uploadingPhoto}
              style={{borderRadius:"50px",borderColor:NAVY,color:NAVY}}>
              {photoUrl?"Change Photo":"Upload Photo"}
            </Button>
          </Upload>
        </div>

        <Row gutter={[16,0]}>
          <FL label="First Name" field="firstName" />
          <FL label="Last Name" field="lastName" />
          <FL label="Phone" field="phone" />
          <FL label="Company Name" field="companyName" />
          <FL label="Title / Position" field="title" />
          <FL label="Website" field="website" />
          <FL label="License IDs (comma-separated)" field="licenseIds" />
          <FL label="MLS ID" field="mlsId" />
          <Col span={24}>
            <div style={{marginBottom:"16px"}}>
              <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Your Personal URL</label>
              <Input value={form.profileUrl} onChange={e=>this.setForm("profileUrl",e.target.value.replace(/\s+/g,""))}
                addonBefore="myhomebuddha.com/" style={{borderRadius:"10px"}} placeholder="e.g. TracyBarber" />
            </div>
          </Col>
          <Col span={24}>
            <div style={{marginBottom:"16px"}}>
              <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Service Areas</label>
              {/* FIX: wrap in div that stops backspace from propagating to tag removal */}
              <div onKeyDown={e => e.stopPropagation()}>
                <GooglePlacesAutocomplete
                  apiKey={process.env.REACT_APP_MAPS_KEY}
                  autocompletionRequest={{types:["(cities)"],componentRestrictions:{country:["us"]}}}
                  selectProps={{
                    placeholder:"Add a town or city",
                    onChange:(result)=>{
                      const city=result.label.split(",")[0].trim();
                      if(!serviceAreas.includes(city)) this.setState({serviceAreas:[...serviceAreas,city]});
                    },
                  }}
                />
              </div>
              <div style={{marginTop:"8px"}}>
                {serviceAreas.map(a=>(
                  <Tag key={a} closable onClose={()=>this.setState({serviceAreas:serviceAreas.filter(x=>x!==a)})}
                    style={{marginBottom:"4px",borderRadius:"20px"}}>{a}</Tag>
                ))}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div style={{marginBottom:"16px"}}>
              <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Zip Codes Serviced</label>
              <div style={{display:"flex",gap:"8px"}}>
                <Input value={zipInput} onChange={e=>this.setState({zipInput:e.target.value})}
                  placeholder="e.g. 01453" style={{borderRadius:"10px",maxWidth:"140px"}}
                  onPressEnter={()=>{
                    const z=zipInput.trim();
                    if(z&&!zipCodes.includes(z)) this.setState({zipCodes:[...zipCodes,z],zipInput:""});
                  }}/>
                <Button onClick={()=>{
                  const z=zipInput.trim();
                  if(z&&!zipCodes.includes(z)) this.setState({zipCodes:[...zipCodes,z],zipInput:""});
                }} style={{borderRadius:"50px"}}>Add</Button>
              </div>
              <div style={{marginTop:"8px"}}>
                {zipCodes.map(z=>(
                  <Tag key={z} closable onClose={()=>this.setState({zipCodes:zipCodes.filter(c=>c!==z)})}
                    style={{marginBottom:"4px",borderRadius:"20px"}}>{z}</Tag>
                ))}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div style={{marginBottom:"16px"}}>
              <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>About You</label>
              <TextArea rows={4} value={form.userBio} onChange={e=>this.setForm("userBio",e.target.value)}
                placeholder="Share your story, experience, and what makes you different..."
                style={{borderRadius:"10px"}} />
            </div>
          </Col>
          <Col span={24}>
            <div style={{marginBottom:"8px",paddingTop:"8px",borderTop:`1px solid ${BORDER}`}}>
              <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>
                Social Media <span style={{color:MUTED,fontWeight:400,textTransform:"none"}}>(optional — add now or later in profile settings)</span>
              </label>
            </div>
          </Col>
          {[
            ["Facebook URL","facebook","https://www.facebook.com/yourpage",12],
            ["Instagram URL","instagram","https://www.instagram.com/yourhandle",12],
            ["LinkedIn URL","linkedin","https://www.linkedin.com/in/yourname",12],
            ["YouTube URL","youtube","https://www.youtube.com/channel/...",12],
          ].map(([label,field,placeholder,span])=>(
            <Col span={span} key={field}>
              <div style={{marginBottom:"14px"}}>
                <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
                <Input value={form[field]} onChange={e=>this.setForm(field,e.target.value)}
                  placeholder={placeholder} style={{borderRadius:"10px"}} />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  renderPractice() {
    const {form} = this.state;
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Practice</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>Tell us about your real estate expertise.</div>
        {[
          ["Years of Experience / Track Record","experience","e.g. 15 years, 500+ families helped in Central MA",false],
          ["Your Unique Angle","unique_angle","e.g. Former construction manager — I catch what other agents miss",true],
        ].map(([label,field,placeholder,multi])=>(
          <div key={field} style={{marginBottom:"16px"}}>
            <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
            {multi
              ? <TextArea rows={3} value={form[field]} onChange={e=>this.setForm(field,e.target.value)} placeholder={placeholder} style={{borderRadius:"10px"}} />
              : <Input value={form[field]} onChange={e=>this.setForm(field,e.target.value)} placeholder={placeholder} style={{borderRadius:"10px"}} />
            }
          </div>
        ))}
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Specialties</label>
          {SPECIALTIES.map(s=>(
            <span key={s} style={chip(form.specialties?.includes(s))} onClick={()=>this.toggleChip("specialties",s,10)}>{s}</span>
          ))}
        </div>
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Price Range</label>
          <Select value={form.price_range||undefined} onChange={v=>this.setForm("price_range",v)}
            placeholder="Select range"
            style={{width:"100%",borderRadius:"10px"}}
            getPopupContainer={trigger=>trigger.parentNode}
            dropdownStyle={{zIndex:99999}}>
            {["Under $300K","$300K-$500K","$500K-$750K","$750K-$1M","$1M-$2M","$2M+","All ranges"].map(r=>(
              <Option key={r} value={r}>{r}</Option>
            ))}
          </Select>
        </div>
      </div>
    );
  }

  renderClients() {
    const {form} = this.state;
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Clients</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>Who do you love working with most?</div>
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Client Types</label>
          {CLIENT_TYPES.map(ct=>(
            <span key={ct} style={chip(form.client_types?.includes(ct))} onClick={()=>this.toggleChip("client_types",ct)}>{ct}</span>
          ))}
        </div>
      </div>
    );
  }

  renderVoice() {
    const {form} = this.state;
    const Sec = ({label,field,options})=>(
      <div style={{marginBottom:"16px"}}>
        <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
        <div>{options.map(([val,desc])=>(
          <Tooltip key={val} title={desc}>
            <span style={chip(form[field]===val)} onClick={()=>this.setForm(field,val)}>{val}</span>
          </Tooltip>
        ))}</div>
      </div>
    );
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Voice</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>Shapes how your AI content sounds. Pick what feels like you.</div>
        <Sec label="Tone" field="voice_tone" options={[
          ["Professional","Polished and authoritative"],["Conversational","Warm and approachable"],
          ["Bold","Confident and direct"],["Warm","Empathetic and caring"],
        ]} />
        <Sec label="Emoji Usage" field="emoji_usage" options={[
          ["Never","Clean, text-only"],["Sometimes","1-2 when they add meaning"],["Often","Emojis for personality"],
        ]} />
        <Sec label="Opinion Level" field="opinion_level" options={[
          ["Factual","Just the facts"],["Balanced","Facts with perspective"],["Opinionated","Strong takes"],
        ]} />
        <Sec label="Call to Action Style" field="cta_style" options={[
          ["Soft","Feel free to reach out"],["Direct","Call me when you're ready"],["Urgent","Limited inventory — let's talk now"],
        ]} />
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>One Word That Describes Your Brand</label>
          <Input value={form.brand_word} onChange={e=>this.setForm("brand_word",e.target.value)}
            placeholder="e.g. Trusted / Bold / Neighborly / Relentless"
            style={{borderRadius:"10px",maxWidth:"300px"}} />
        </div>
      </div>
    );
  }

  renderContent() {
    const {form} = this.state;
    const CG = ({label,field,options,multi})=>(
      <div style={{marginBottom:"16px"}}>
        <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
        <div>{options.map(opt=>(
          <span key={opt}
            style={chip(multi ? form[field]?.includes(opt) : form[field]===opt)}
            onClick={()=>{
              if(multi) this.toggleChip(field,opt);
              else this.setForm(field,form[field]===opt?"":opt);
            }}>{opt}</span>
        ))}</div>
      </div>
    );
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Content Strategy</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>How you like to show up for your audience.</div>
        <CG label="Platforms" field="platforms" multi options={["Instagram","Facebook","LinkedIn","YouTube","TikTok","Email newsletter"]} />
        <CG label="Posting Frequency" field="posting_freq" options={["Daily","A few times a week","Weekly","A few times a month"]} />
        <CG label="Post Length" field="post_length" options={["Short (1-2 sentences)","Medium (1 paragraph)","Long (storytelling)"]} />
        <CG label="Content Mix" field="content_mix" multi options={["Market updates","Listings","Client stories","Local tips","Personal/lifestyle","Educational"]} />
      </div>
    );
  }

  renderLife() {
    const {form} = this.state;
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Your Life</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px",lineHeight:1.5}}>
          The secret sauce. More personality = AI content that sounds like a real human, not a generic agent.
        </div>
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Hobbies & Interests</label>
          {HOBBIES.map(h=>(
            <span key={h} style={chip(form.hobbies?.includes(h))} onClick={()=>this.toggleChip("hobbies",h)}>{h}</span>
          ))}
        </div>
        <div style={{marginBottom:"16px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>Why You Do This Work <span style={{color:MUTED,fontWeight:400}}>(pick up to 2)</span></label>
          {WHY_VALUES.map(w=>(
            <span key={w} style={chip(form.why_values?.includes(w))} onClick={()=>this.toggleChip("why_values",w,2)}>{w}</span>
          ))}
        </div>
        <Row gutter={[16,0]}>
          {[
            ["Family / Life Stage","family_stage","e.g. Dad of 3, Newlywed, Empty nester"],
            ["Where You Grew Up","grew_up","e.g. Grew up in Worcester, MA"],
            ["Your Origin Story","origin_story","What led you to real estate?"],
            ["A Fun Fact About You","fun_fact","e.g. I've run 12 marathons"],
            ["What You Love About Your Area","local_love","What makes your market special?"],
            ["What a Great Work Day Looks Like","great_work_day","e.g. Morning showing, coffee with clients, closing day"],
          ].map(([label,field,placeholder])=>(
            <Col span={24} key={field}>
              <div style={{marginBottom:"14px"}}>
                <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em",display:"block",marginBottom:"4px"}}>{label}</label>
                <TextArea rows={2} value={form[field]} onChange={e=>this.setForm(field,e.target.value)} placeholder={placeholder} style={{borderRadius:"10px"}} />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  renderPreview() {
    const {previewPost,generatingPreview} = this.state;
    const strength = this.calcStrength();
    return (
      <div>
        <div style={{fontSize:"22px",fontWeight:800,color:NAVY,marginBottom:"4px"}}>Profile Preview</div>
        <div style={{fontSize:"13px",color:MUTED,marginBottom:"20px"}}>Your profile strength and a sample AI post.</div>
        <div style={{textAlign:"center",marginBottom:"24px"}}>
          <Progress type="circle" percent={strength}
            strokeColor={strength>=75?SUCCESS:GOLD}
            trailColor={BORDER} strokeWidth={10}
            format={pct=>(
              <div>
                <div style={{fontSize:"24px",fontWeight:800,color:pct>=75?SUCCESS:GOLD}}>{pct}%</div>
                <div style={{fontSize:"11px",color:MUTED}}>{pct>=75?"Ready!":"Fill more sections"}</div>
              </div>
            )} width={120} />
          {strength<75 && (
            <div style={{marginTop:"10px",color:MUTED,fontSize:"13px"}}>
              Profile is {strength}% complete. You can save now and finish later in Profile Settings.
            </div>
          )}
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"12px"}}>
          <label style={{fontSize:"11px",fontWeight:700,color:NAVY,textTransform:"uppercase",letterSpacing:".05em"}}>Sample AI Post</label>
          <Button onClick={this.generatePreview} loading={generatingPreview} size="small"
            style={{borderRadius:"50px",borderColor:NAVY,color:NAVY,fontSize:"12px"}}>
            {previewPost?"Regenerate":"✨ Generate"}
          </Button>
        </div>
        {generatingPreview && (
          <div style={{textAlign:"center",padding:"30px",color:MUTED}}>
            <Spin indicator={<LoadingOutlined style={{fontSize:24}} spin />} />
            <div style={{marginTop:"12px"}}>Writing your post...</div>
          </div>
        )}
        {previewPost && !generatingPreview && (
          <div style={{background:"#fff",borderRadius:"14px",border:`1.5px solid ${BORDER}`,padding:"20px",fontSize:"14px",lineHeight:1.7,fontFamily:"Georgia,serif",whiteSpace:"pre-wrap"}}>{previewPost}</div>
        )}
        {!previewPost && !generatingPreview && (
          <div style={{background:"#fff",borderRadius:"14px",border:`1.5px solid ${BORDER}`,padding:"40px",textAlign:"center",color:MUTED,fontStyle:"italic"}}>
            Click Generate to see a sample post in your voice
          </div>
        )}
        {strength>=75 && (
          <div style={{marginTop:"20px",padding:"16px",background:"#F0FFF4",borderRadius:"12px",border:`1.5px solid ${SUCCESS}`,textAlign:"center"}}>
            <CheckCircleFilled style={{color:SUCCESS,fontSize:"20px",marginBottom:"6px",display:"block"}} />
            <div style={{fontWeight:700,color:SUCCESS}}>Profile ready to launch!</div>
            <div style={{fontSize:"13px",color:MUTED,marginTop:"4px"}}>Click "Complete Profile" below.</div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {step,saving,aiScanDone} = this.state;
    const referrerOnly = this.props.referrerOnly || false;

    // ── Referrer-only mode ────────────────────────────────────────────────────
    if (referrerOnly) {
      const { invitedByAgentId, saving } = this.state;
      return (
        <div style={{position:"fixed",inset:0,background:"rgba(10,15,40,0.78)",backdropFilter:"blur(4px)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:"16px"}}>
          <div style={{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"520px",display:"flex",flexDirection:"column",boxShadow:"0 32px 80px rgba(26,34,128,0.25)",overflow:"hidden"}}>
            <div style={{background:`linear-gradient(135deg,${NAVY},#2A3390)`,padding:"18px 28px 14px",borderBottom:`3px solid ${GOLD}`,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{color:GOLD,fontWeight:800,fontSize:"16px"}}>My Home Buddha</div>
                <div style={{color:"rgba(255,255,255,0.7)",fontSize:"12px",marginTop:"2px"}}>One quick thing before you continue</div>
              </div>
              {/* FIX: X button on referrer-only modal */}
              <button onClick={this.handleDismiss} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:"50%",width:"28px",height:"28px",cursor:"pointer",color:"#fff",fontSize:"14px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <CloseOutlined />
              </button>
            </div>
            <div style={{padding:"28px",background:BG}}>
              {this.renderInvitedBy()}
            </div>
            <div style={{padding:"16px 28px",background:"#fff",borderTop:`1px solid ${BORDER}`,display:"flex",alignItems:"center",justifyContent:"flex-end",gap:"10px"}}>
              <Button onClick={()=>{
                if (invitedByAgentId && invitedByAgentId !== "none" && invitedByAgentId !== "") {
                  this.handleSaveReferrerOnly();
                } else {
                  this.props.onComplete();
                }
              }} style={{...btn("gold")}}>
                {invitedByAgentId && invitedByAgentId !== "none" ? "Save & Continue →" : "Skip for Now →"}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    // ── Full profile completion modal ─────────────────────────────────────────
    const isLast = step===STEPS.length-1;
    // FIX: canNext is always true — removed the aiScanDone gate that trapped users
    const canNext = true;
    const strength = this.calcStrength();
    const stepContent = [
      this.renderAIScan(),
      this.renderInvitedBy(),
      this.renderBasics(),
      this.renderPractice(),
      this.renderClients(),
      this.renderVoice(),
      this.renderContent(),
      this.renderLife(),
      this.renderPreview(),
    ][step];

    return (
      <div style={{position:"fixed",inset:0,background:"rgba(10,15,40,0.78)",backdropFilter:"blur(4px)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:"16px"}}>
        <div style={{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"760px",maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 32px 80px rgba(26,34,128,0.25)",overflow:"hidden"}}>

          {/* Header — FIX: added X close button */}
          <div style={{background:`linear-gradient(135deg,${NAVY},#2A3390)`,padding:"18px 28px 14px",borderBottom:`3px solid ${GOLD}`}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"12px"}}>
              <div style={{color:GOLD,fontWeight:800,fontSize:"18px",letterSpacing:"-0.02em"}}>My Home Buddha</div>
              <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
                <div style={{background:"rgba(255,255,255,0.12)",borderRadius:"20px",padding:"4px 12px",color:"#fff",fontSize:"12px",fontWeight:700}}>
                  Profile {strength}% complete
                </div>
                {/* FIX: X close button — saves progress and dismisses */}
                <Tooltip title="Finish later — progress is saved">
                  <button onClick={this.handleDismiss}
                    style={{background:"rgba(255,255,255,0.15)",border:"1.5px solid rgba(255,255,255,0.3)",borderRadius:"50%",width:"32px",height:"32px",cursor:"pointer",color:"#fff",fontSize:"14px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <CloseOutlined />
                  </button>
                </Tooltip>
              </div>
            </div>
            <div style={{display:"flex",gap:"4px",overflowX:"auto",paddingBottom:"2px"}}>
              {STEPS.map((st,i)=>(
                <div key={st.id}
                  onClick={()=>i<step&&this.setState({step:i})}
                  style={{
                    display:"flex",alignItems:"center",gap:"5px",
                    padding:"5px 10px",borderRadius:"20px",fontSize:"11px",
                    fontWeight:i===step?700:500,whiteSpace:"nowrap",
                    background:i===step?GOLD:i<step?"rgba(212,146,26,0.2)":"rgba(255,255,255,0.08)",
                    color:i===step?"#2A1600":i<step?GOLD:"rgba(255,255,255,0.55)",
                    cursor:i<step?"pointer":"default",transition:"all .2s",
                  }}>
                  {i<step?<CheckCircleFilled />:st.icon}
                  <span>{st.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Body */}
          <div style={{flex:1,overflowY:"auto",padding:"28px",background:BG}}>
            {stepContent}
          </div>

          {/* Footer — FIX: added Finish Later button, removed hard save block */}
          <div style={{padding:"16px 28px",background:"#fff",borderTop:`1px solid ${BORDER}`,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
              <div style={{fontSize:"12px",color:MUTED}}>{isLast?"":  `Step ${step+1} of ${STEPS.length}`}</div>
              {/* FIX: Finish Later link always visible */}
              <button onClick={this.handleDismiss}
                style={{background:"none",border:"none",color:MUTED,fontSize:"12px",cursor:"pointer",textDecoration:"underline",padding:0}}>
                Finish later
              </button>
            </div>
            <div style={{display:"flex",gap:"10px"}}>
              {step>0 && (
                <Button onClick={()=>this.setState(p=>({step:p.step-1}))} style={btn("ghost")}>← Back</Button>
              )}
              {isLast ? (
                // FIX: Save always enabled — warn if under 75% but don't block
                <Button onClick={this.handleSave} loading={saving}
                  style={btn("gold")}>
                  {strength>=75 ? "🚀 Complete Profile" : "💾 Save & Finish Later"}
                </Button>
              ) : (
                // FIX: canNext always true — no more getting stuck on step 0
                <Button onClick={()=>{
                  // On AI scan step, if they haven't run the scan yet, run it then advance
                  if(step===0 && !aiScanDone) {
                    this.runAIScan().then(()=>this.setState(p=>({step:p.step+1})));
                  } else {
                    this.setState(p=>({step:p.step+1}));
                  }
                }}
                  style={btn("primary")}>
                  {step===0 && !aiScanDone ? "✨ Run AI Scan & Continue" : "Continue →"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppContext(ProfileCompletionModal);